var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TranscriptSummaryPanel", {
        attrs: {
          summary: _vm.summary,
          "ai-status": _vm.aiStatus,
          "transcript-status": _vm.transcriptStatus,
          loading: _vm.loading,
          "can-regenerate": _vm.canRegenerate
        },
        on: {
          regenerate: function($event) {
            return _vm.$emit("regenerate")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }